import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=513b5fc9&"
import script from "./projects.vue?vue&type=script&lang=ts&"
export * from "./projects.vue?vue&type=script&lang=ts&"
import style0 from "./projects.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports